import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 17h14v2H5v-2zm7-12L5.33 15h13.34L12 5z"
}), 'EjectSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/EjectSharp.js
// module id = 3321
// module chunks = 2